var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 328,
    viewBox: "0 0 1001 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.222 230.182C322.613 230.182 326.978 225.813 326.978 220.422C326.978 151.092 326.978 79.8981 326.978 10.5678C326.978 5.17722 322.608 0.808777 317.218 0.808777H263.535C258.145 0.808777 253.775 5.17233 253.775 10.5629C253.774 78.0523 253.774 152.938 253.774 220.427C253.774 225.818 258.139 230.182 263.53 230.182C280.331 230.182 300.421 230.182 317.222 230.182Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.222 230.182C322.613 230.182 326.978 225.813 326.978 220.422C326.978 151.092 326.978 79.8981 326.978 10.5678C326.978 5.17722 322.608 0.808777 317.218 0.808777H263.535C258.145 0.808777 253.775 5.17233 253.775 10.5629C253.774 78.0523 253.774 152.938 253.774 220.427C253.774 225.818 258.139 230.182 263.53 230.182C280.331 230.182 300.421 230.182 317.222 230.182Z",
    fill: "url(#paint0_linear_3733_55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4435 230.182C68.8341 230.182 73.2041 225.812 73.2041 220.421V146.826H107.366L151.288 225.301C152.46 227.205 156.169 230.182 161.049 230.182H224.492C229.568 230.182 232.008 224.667 229.373 220.421L165.929 112.713L229.373 10.5693C232.35 6.32348 229.714 0.808777 224.492 0.808777H156.169C151.288 0.808777 147.579 3.93215 146.408 5.68905L102.486 83.4318H73.2041C73.2041 59.2219 72.7944 34.9734 73.0561 10.7578C73.1151 5.29405 68.718 0.808777 63.2539 0.808777H9.7605C4.36993 0.808777 3.30124e-06 5.17866 -4.07059e-05 10.5692C-0.000611764 80.5198 0 150.47 0 220.421C0 225.812 4.36994 230.182 9.76054 230.182C27.6549 230.182 45.5492 230.182 63.4435 230.182Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4435 230.182C68.8341 230.182 73.2041 225.812 73.2041 220.421V146.826H107.366L151.288 225.301C152.46 227.205 156.169 230.182 161.049 230.182H224.492C229.568 230.182 232.008 224.667 229.373 220.421L165.929 112.713L229.373 10.5693C232.35 6.32348 229.714 0.808777 224.492 0.808777H156.169C151.288 0.808777 147.579 3.93215 146.408 5.68905L102.486 83.4318H73.2041C73.2041 59.2219 72.7944 34.9734 73.0561 10.7578C73.1151 5.29405 68.718 0.808777 63.2539 0.808777H9.7605C4.36993 0.808777 3.30124e-06 5.17866 -4.07059e-05 10.5692C-0.000611764 80.5198 0 150.47 0 220.421C0 225.812 4.36994 230.182 9.76054 230.182C27.6549 230.182 45.5492 230.182 63.4435 230.182Z",
    fill: "url(#paint1_linear_3733_55)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M990.696 230.182C996.086 230.182 1000.46 225.812 1000.46 220.421C1000.46 150.47 1000.46 80.519 1000.46 10.568C1000.46 5.17796 996.087 0.808814 990.697 0.808814H937.013C931.622 0.808814 927.252 5.1786 927.252 10.5691C927.252 46.3578 927.252 82.1466 927.252 117.935L834.527 0.808801C813.379 0.808801 792.231 0.808753 771.084 0.808792C765.693 0.808802 761.323 5.17874 761.323 10.5693C761.323 80.52 761.321 150.471 761.323 220.421C761.323 225.812 765.693 230.182 771.083 230.182H824.766C830.157 230.182 834.527 225.811 834.527 220.421C834.526 184.518 834.527 148.616 834.527 112.713L927.252 230.182H990.696Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M990.696 230.182C996.086 230.182 1000.46 225.812 1000.46 220.421C1000.46 150.47 1000.46 80.519 1000.46 10.568C1000.46 5.17796 996.087 0.808814 990.697 0.808814H937.013C931.622 0.808814 927.252 5.1786 927.252 10.5691C927.252 46.3578 927.252 82.1466 927.252 117.935L834.527 0.808801C813.379 0.808801 792.231 0.808753 771.084 0.808792C765.693 0.808802 761.323 5.17874 761.323 10.5693C761.323 80.52 761.321 150.471 761.323 220.421C761.323 225.812 765.693 230.182 771.083 230.182H824.766C830.157 230.182 834.527 225.811 834.527 220.421C834.526 184.518 834.527 148.616 834.527 112.713L927.252 230.182H990.696Z",
    fill: "url(#paint2_linear_3733_55)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M356.26 220.421C356.259 225.811 360.629 230.182 366.02 230.182C484.773 230.182 603.527 230.182 722.28 230.182C727.67 230.182 732.04 225.812 732.04 220.421C732.04 150.471 732.037 80.5202 732.04 10.5698C732.04 5.17902 727.67 0.808777 722.279 0.808777H366.02C360.629 0.808777 356.259 5.17865 356.259 10.5692C356.259 80.5197 356.261 150.47 356.26 220.421ZM434.344 59.372C456.403 63.6667 502.424 64.3011 545.468 64.2035C590.073 64.1059 634.728 63.1786 653.956 59.372C655.859 58.9816 658.836 59.3232 658.836 64.2035V161.663C658.836 166.738 655.762 166.738 653.956 166.543C634.923 164.2 589.927 162.004 545.468 161.858C501.008 161.711 453.084 164.005 434.344 166.738C432.489 166.982 429.463 166.933 429.463 161.858V64.2523C429.463 59.372 432.489 59.0304 434.344 59.372Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M356.26 220.421C356.259 225.811 360.629 230.182 366.02 230.182C484.773 230.182 603.527 230.182 722.28 230.182C727.67 230.182 732.04 225.812 732.04 220.421C732.04 150.471 732.037 80.5202 732.04 10.5698C732.04 5.17902 727.67 0.808777 722.279 0.808777H366.02C360.629 0.808777 356.259 5.17865 356.259 10.5692C356.259 80.5197 356.261 150.47 356.26 220.421ZM434.344 59.372C456.403 63.6667 502.424 64.3011 545.468 64.2035C590.073 64.1059 634.728 63.1786 653.956 59.372C655.859 58.9816 658.836 59.3232 658.836 64.2035V161.663C658.836 166.738 655.762 166.738 653.956 166.543C634.923 164.2 589.927 162.004 545.468 161.858C501.008 161.711 453.084 164.005 434.344 166.738C432.489 166.982 429.463 166.933 429.463 161.858V64.2523C429.463 59.372 432.489 59.0304 434.344 59.372Z",
    fill: "url(#paint3_linear_3733_55)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8323 282.953C44.1026 282.953 53.6647 288.368 53.6647 305.101C53.6647 321.835 44.1026 327.738 26.8323 327.738C9.56207 327.738 0 322.274 0 305.101C0 287.929 9.56207 282.953 26.8323 282.953ZM41.8584 303.004C41.8584 294.759 36.7847 291.978 26.8323 291.978C16.88 291.978 11.7087 294.808 11.7087 303.004V307.541C11.7087 316.225 16.8312 318.762 26.8323 318.762C36.8335 318.762 41.8584 316.273 41.8584 307.541V303.004ZM72.2522 283.831V300.125H95.1816V283.831H106.793V326.909H95.1816V309.541H72.2522V326.909H60.6411V283.831H72.2522ZM113.915 316.664C119.477 316.664 120.355 312.273 120.355 301.686V283.831H160.604V326.909H148.993V293.246H131.186V301.686C131.186 320.274 128.307 326.909 115.769 326.909H112.403V316.664H113.915ZM199.876 283.831L218.415 326.909H206.365L202.267 317.298H180.216L176.166 326.909H165.238L183.923 283.831H199.925H199.876ZM183.826 308.858H198.657L191.241 291.441L183.826 308.858ZM235.588 326.909H223.099V283.831H234.71V312.663L257.883 283.831H270.372V326.909H258.761V298.076L235.588 326.909ZM241.442 270.854C241.637 274.269 243.247 275.488 246.565 275.488C249.882 275.488 251.541 274.317 251.736 270.854H261.054C260.859 278.074 256.322 281.733 246.565 281.733C236.808 281.733 232.319 278.123 232.124 270.854H241.442ZM290.862 283.831V300.125H313.792V283.831H325.403V326.909H313.792V309.541H290.862V326.909H279.251V283.831H290.862ZM355.992 299.979V309.59H333.355V299.979H355.992ZM409.998 283.831L390.386 304.37L411.169 326.909H396.435L380.287 309.541H375.604V326.909H363.993V283.831H375.604V300.125H380.678L396.338 283.831H409.998ZM427.854 326.909H415.364V283.831H426.976V312.663L450.149 283.831H462.638V326.909H451.027V298.076L427.854 326.909ZM483.128 283.831V300.125H506.058V283.831H517.669V326.909H506.058V309.541H483.128V326.909H471.517V283.831H483.128ZM551.478 282.953C568.748 282.953 578.31 288.368 578.31 305.101C578.31 321.835 568.748 327.738 551.478 327.738C534.207 327.738 524.645 322.225 524.645 305.101C524.645 287.978 534.207 282.953 551.478 282.953ZM566.504 303.004C566.504 294.759 561.43 291.978 551.478 291.978C541.525 291.978 536.354 294.808 536.354 303.004V307.541C536.354 316.225 541.476 318.762 551.478 318.762C561.479 318.762 566.504 316.273 566.504 307.541V303.004ZM582.018 293.246V283.831H628.511V293.246H611.045V326.909H599.434V293.246H582.018ZM673.345 292.759H645.683V300.613H666.71V309.151H645.683V317.932H673.54V326.86H634.072V283.782H673.345V292.759ZM711.008 283.831L729.547 326.909H717.497L713.398 317.298H691.347L687.298 326.909H676.37L695.055 283.831H711.057H711.008ZM694.957 308.858H709.788L702.373 291.441L694.957 308.858ZM723.79 293.246V283.831H770.283V293.246H752.818V326.909H741.206V293.246H723.79ZM805.214 283.831C815.898 283.831 820.777 289.246 820.777 298.515C820.777 307.785 815.898 313.444 805.214 313.444H787.505V326.909H775.893V283.831H805.214ZM809.019 297.735C809.019 294.905 807.409 292.807 803.604 292.807H787.505V304.418H803.604C807.409 304.418 809.019 302.418 809.019 299.442V297.735ZM850.341 293.637V326.909H839.706V283.831H858L868.685 315.981L879.417 283.831H897.078V326.909H885.467V293.49L874.246 326.909H861.562L850.341 293.637ZM902.688 293.246V283.831H949.181V293.246H931.716V326.909H920.105V293.246H902.688ZM976.111 282.953C990.552 282.953 999.187 287.051 1000.41 298.759H988.649C987.625 293.246 983.429 291.978 976.111 291.978C968.306 291.978 962.793 293.978 962.793 302.955V307.882C962.793 316.615 968.11 318.81 976.16 318.81C983.088 318.81 987.479 317.542 988.698 312.419H1000.46C999.09 323.543 990.455 327.787 976.111 327.787C960.402 327.787 951.084 322.372 951.084 305.443C951.084 288.514 960.402 282.953 976.111 282.953Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8323 282.953C44.1026 282.953 53.6647 288.368 53.6647 305.101C53.6647 321.835 44.1026 327.738 26.8323 327.738C9.56207 327.738 0 322.274 0 305.101C0 287.929 9.56207 282.953 26.8323 282.953ZM41.8584 303.004C41.8584 294.759 36.7847 291.978 26.8323 291.978C16.88 291.978 11.7087 294.808 11.7087 303.004V307.541C11.7087 316.225 16.8312 318.762 26.8323 318.762C36.8335 318.762 41.8584 316.273 41.8584 307.541V303.004ZM72.2522 283.831V300.125H95.1816V283.831H106.793V326.909H95.1816V309.541H72.2522V326.909H60.6411V283.831H72.2522ZM113.915 316.664C119.477 316.664 120.355 312.273 120.355 301.686V283.831H160.604V326.909H148.993V293.246H131.186V301.686C131.186 320.274 128.307 326.909 115.769 326.909H112.403V316.664H113.915ZM199.876 283.831L218.415 326.909H206.365L202.267 317.298H180.216L176.166 326.909H165.238L183.923 283.831H199.925H199.876ZM183.826 308.858H198.657L191.241 291.441L183.826 308.858ZM235.588 326.909H223.099V283.831H234.71V312.663L257.883 283.831H270.372V326.909H258.761V298.076L235.588 326.909ZM241.442 270.854C241.637 274.269 243.247 275.488 246.565 275.488C249.882 275.488 251.541 274.317 251.736 270.854H261.054C260.859 278.074 256.322 281.733 246.565 281.733C236.808 281.733 232.319 278.123 232.124 270.854H241.442ZM290.862 283.831V300.125H313.792V283.831H325.403V326.909H313.792V309.541H290.862V326.909H279.251V283.831H290.862ZM355.992 299.979V309.59H333.355V299.979H355.992ZM409.998 283.831L390.386 304.37L411.169 326.909H396.435L380.287 309.541H375.604V326.909H363.993V283.831H375.604V300.125H380.678L396.338 283.831H409.998ZM427.854 326.909H415.364V283.831H426.976V312.663L450.149 283.831H462.638V326.909H451.027V298.076L427.854 326.909ZM483.128 283.831V300.125H506.058V283.831H517.669V326.909H506.058V309.541H483.128V326.909H471.517V283.831H483.128ZM551.478 282.953C568.748 282.953 578.31 288.368 578.31 305.101C578.31 321.835 568.748 327.738 551.478 327.738C534.207 327.738 524.645 322.225 524.645 305.101C524.645 287.978 534.207 282.953 551.478 282.953ZM566.504 303.004C566.504 294.759 561.43 291.978 551.478 291.978C541.525 291.978 536.354 294.808 536.354 303.004V307.541C536.354 316.225 541.476 318.762 551.478 318.762C561.479 318.762 566.504 316.273 566.504 307.541V303.004ZM582.018 293.246V283.831H628.511V293.246H611.045V326.909H599.434V293.246H582.018ZM673.345 292.759H645.683V300.613H666.71V309.151H645.683V317.932H673.54V326.86H634.072V283.782H673.345V292.759ZM711.008 283.831L729.547 326.909H717.497L713.398 317.298H691.347L687.298 326.909H676.37L695.055 283.831H711.057H711.008ZM694.957 308.858H709.788L702.373 291.441L694.957 308.858ZM723.79 293.246V283.831H770.283V293.246H752.818V326.909H741.206V293.246H723.79ZM805.214 283.831C815.898 283.831 820.777 289.246 820.777 298.515C820.777 307.785 815.898 313.444 805.214 313.444H787.505V326.909H775.893V283.831H805.214ZM809.019 297.735C809.019 294.905 807.409 292.807 803.604 292.807H787.505V304.418H803.604C807.409 304.418 809.019 302.418 809.019 299.442V297.735ZM850.341 293.637V326.909H839.706V283.831H858L868.685 315.981L879.417 283.831H897.078V326.909H885.467V293.49L874.246 326.909H861.562L850.341 293.637ZM902.688 293.246V283.831H949.181V293.246H931.716V326.909H920.105V293.246H902.688ZM976.111 282.953C990.552 282.953 999.187 287.051 1000.41 298.759H988.649C987.625 293.246 983.429 291.978 976.111 291.978C968.306 291.978 962.793 293.978 962.793 302.955V307.882C962.793 316.615 968.11 318.81 976.16 318.81C983.088 318.81 987.479 317.542 988.698 312.419H1000.46C999.09 323.543 990.455 327.787 976.111 327.787C960.402 327.787 951.084 322.372 951.084 305.443C951.084 288.514 960.402 282.953 976.111 282.953Z",
    fill: "url(#paint4_linear_3733_55)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3733_55",
    x1: 252.652,
    y1: 281.132,
    x2: 372.827,
    y2: -245.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3973B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#355DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#334093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#303189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2E2B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C40D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C81163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CB1353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CE1445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D01437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D2132C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D31323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D4131D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D41319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3733_55",
    x1: 86.82,
    y1: 243.261,
    x2: 206.924,
    y2: -283.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3973B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#355DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#334093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#303189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2E2B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C40D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C81163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CB1353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CE1445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D01437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D2132C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D31323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D4131D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D41319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3733_55",
    x1: 813.933,
    y1: 409.044,
    x2: 933.985,
    y2: -117.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3973B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#355DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#334093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#303189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2E2B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C40D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C81163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CB1353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CE1445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D01437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D2132C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D31323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D4131D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D41319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3733_55",
    x1: 493.785,
    y1: 336.523,
    x2: 613.84,
    y2: -190.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3973B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#355DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#334093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#303189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2E2B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C40D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C81163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CB1353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CE1445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D01437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D2132C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D31323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D4131D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D41319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3733_55",
    x1: -192.022,
    y1: 470.437,
    x2: 1957,
    y2: -41.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3973B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3870B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3768B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#355DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#334093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#303189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2E2B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C40D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C81163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CB1353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#CE1445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D01437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D2132C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D31323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D4131D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D41319"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRed);
export default __webpack_public_path__ + "static/media/logo-red.e42aa4674dc436d4f94bebcd2acda7f3.svg";
export { ForwardRef as ReactComponent };